export type Voidish = null | undefined | false
export type MaybeVoidish<T = any> = T | Voidish;

export const isVoidish = (x: any): x is Voidish => (typeof x === 'undefined' || x === null || x === false);
export const isNotVoidish = <T = any>(x: T): x is Exclude<typeof x, Voidish> => !isVoidish(x);
